<template>
  <div id="trendsPage">
    <NavBar class="overflow-y-hidden"/>
    <v-main class="overflow-hidden">
      <div class="container-fluid">
        <div class="row mt-2">
          <div class="col-auto pt-0 pl-0">
            <v-btn icon to="/">
              <i class="fa-solid fa-arrow-right fa-xl"></i></v-btn>
          </div>
          <div class="col pt-0 px-0">
            <v-text-field
                v-model="searchKeyWord"
                append-icon="far fa-magnifying-glass"
                class="rounded-lg"
                dense
                flat
                hide-details
                solo
                @keyup="search($event)"
                @click:clear="removeSearchHistory"
                @click:append="searchBtn">
            </v-text-field>
          </div>
          <div class="col-auto pt-0 pr-1">
            <v-btn icon @click="openFilterSheet = true">
              <i class="fa-solid fa-sliders fa-xl"></i>
            </v-btn>
          </div>
        </div>
        <HashtagsBar/>
        <div v-if="posts.length <= 0" class="col-12  mt-16 text-center">
          <div><i class="fa-light fa-face-frown-slight fa-3x grey--text"></i></div>
          <div class="mt-2">
            موارد بیشتری یافت نشد
          </div>

        </div>
        <masonry
            v-else
            :cols="{default: 4, 1000: 3, 700: 2}"
            class="mt-4">
          <router-link v-for="(item,i) in posts" :key="i"
                       :to="{name:'TrendDetail',query:{VendorSocialNetworkID:item.VendorSocialNetworkID}}"
                       class="p-1 mx-auto d-block">
            <v-img v-if="item.FileCoverUrl !== null" :src="$replaceHttps(item.FileCoverUrl)" class=" rounded-11px" laz>
              <div class="p-2">
                <div v-if="item.TypeStrucGallery ===2"><i class="fa-solid fa-play white--text fa-lg shadow-lg"></i>
                </div>
                <div v-if="item.TypeStrucGallery ===1"><i class="fa-solid fa-images white--text fa-lg shadow"></i></div>
              </div>
            </v-img>
            <v-img v-else-if="item.TypeStrucGallery===1" :src="$replaceHttps(item.FileUrl)" class=" rounded-11px">
              <div class="p-2">
                <div v-if="item.TypeStrucGallery ===2"><i class="fa-solid fa-play white--text fa-lg shadow-lg"></i>
                </div>
                <div v-if="item.TypeStrucGallery ===1"><i class="fa-solid fa-images white--text fa-lg shadow"></i></div>
              </div>
            </v-img>
          </router-link>
        </masonry>
        <div v-observe-visibility="visibilityChanged" class="col-12">
          <div v-if="isVisible && this.pageIndex >1"  class="row align-items-center">
            <div class="col-12 text-center">
              <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
              ></v-progress-circular>
            </div>
          </div>
        </div>
        <v-bottom-sheet v-model="openFilterSheet" class="bottom-sheet">
          <v-sheet
              class="rounded-t-xl">
            <div class="row no-gutters align-items-center">
              <div class="col-auto font-weight-bold pr-8 primary-text">
                <i class="fa-solid fa-sliders fa-xl"></i>
              </div>
              <div class="col pr-5 py-2 toggle-filter-btn">
                <v-btn-toggle
                    v-model="filterSelected"
                    group
                    tile
                    @change="filterPost">
                  <v-btn value="1">
                    همه
                  </v-btn>
                  <v-btn value="2">
                    عکس
                  </v-btn>
                  <v-btn value="3">
                    فیلم
                  </v-btn>
                </v-btn-toggle>
              </div>
              <div class="col text-left pl-4">
                <v-btn
                    icon
                    @click="openFilterSheet = !openFilterSheet">
           <span class="fa-stack font16px bottom-sheet">
             <i class="fa-solid fa-clock-seven fa-stack-2x black--text"></i>
             <i class="fa-solid fa-circle-xmark fa-stack-1x fa-inverse white--text"></i>
           </span>
                </v-btn>
              </div>
            </div>

          </v-sheet>
        </v-bottom-sheet>
      </div>
    </v-main>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import HashtagsBar from "@/components/HashtagsBar";

export default {
  name: "Trends",
  metaInfo: {
    title: 'ایوان خانه- ترندها',
  },
  components: {
    HashtagsBar,
    NavBar,
  },
  data: () => ({
    filterSelected: 1,
    posts: [],
    searchKeyWord: null,
    showLoaderDialog: false,
    openFilterSheet: false,
    categoriesLoading: true,
    hashtags: [],
    pageIndex:0,
    isVisible: true,
  }),
  destroyed() {
    window.onscroll = undefined
  },
  mounted() {
    this.getPosts()
    // window.onscroll = () => {
    //   if ((window.scrollY + window.innerHeight >= document.body.scrollHeight)) {
    //     this.pageIndex++
    //     this.getPosts()
    //   }
    // }
  },
  watch: {
    '$route.query.ID'() {
      this.getPosts()
    }
  },
  methods: {
    visibilityChanged (isVisible) {
      this.isVisible = isVisible
      if(isVisible) {
        this.pageIndex++
        this.getPosts()
      }
    },
    getPosts() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("pageIndex", this.pageIndex);
      urlencoded.append("pageSize", "10");
      urlencoded.append("TypeSocialNetworkSort", this.filterSelected);
      let hashtagID = this.$route.query.ID
      if (hashtagID !== undefined && hashtagID !== null) {
        urlencoded.append("HashTagID", hashtagID);
      }
      if (this.searchKeyWord !== null && this.searchKeyWord !== '') {
        urlencoded.append("KeyWord", this.searchKeyWord);
      }

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "SearchSocialNetwork/_List", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              let json = (JSON.parse(result).list).filter(x => x.IsActive === true)
              if(hashtagID !== undefined){
                this.posts =json
              }else {
                for (let i = 0; i < json.length; i++) {
                  this.posts.push(json[i])
                }
              }
            } else {
              this.posts = []
            }

            this.postLoading = false
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    },
    filterPost() {
      this.pageIndex = 1
      this.posts = []
      this.getPosts()
    },
    search(e) {
      if (e.keyCode === 13) {
        this.posts = []
        this.getPosts()
      }
    },
    removeSearchHistory() {

    },
    searchBtn() {
      this.posts = []
      this.getPosts()
    }
  }
}
</script>

<style scoped>

</style>
